import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './app/App';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// React has taken over — cancel the boot watchdog and clear any overlay it
// already painted. See the watchdog block in index.html for context.
declare global {
  interface Window {
    __bootWatchdog?: ReturnType<typeof setTimeout>;
  }
}
if (window.__bootWatchdog) {
  clearTimeout(window.__bootWatchdog);
  window.__bootWatchdog = undefined;
}
document.getElementById('__boot_error__')?.remove();
